const State = {
  paymentMethodList: [],
  maxSortNumber: 0
}

export default State
